var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceMortgages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -832.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Mortgages",
    transform: "translate(3116.000000, 832.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6871012,24.122 L16.5119381,16.974 C17.6281638,15.256 17.4354341,12.939 15.9257188,11.435 C14.1881408,9.705 11.3734853,9.705 9.63490356,11.435 C7.90033699,13.164 7.90033699,15.97 9.63691116,17.702 C11.1165125,19.175 13.3740589,19.38 15.0845343,18.343 L19.3968595,22.639 L17.1493511,24.878 C16.8030401,25.223 16.8040439,25.78 17.1493511,26.123 L18.7724959,27.742 C19.1188069,28.086 19.6769198,28.086 20.0232308,27.741 L22.2697354,25.501 L22.2857962,25.518 C22.6732631,25.901 23.3026457,25.901 23.688105,25.517 C24.074568,25.133 24.0735642,24.506 23.6871012,24.122 L23.6871012,24.122 Z M30,11 L30,25.052 C30,28.889 26.8781817,32 23.0266007,32 L8.9733993,32 C5.12181831,32 2,28.889 2,25.052 L2,11 L16.1224636,0 L30,11 Z M14.6679573,12.687 C15.7109056,13.727 15.708898,15.409 14.6669535,16.447 C13.625009,17.486 11.9366172,17.486 10.8946727,16.448 C9.85172439,15.41 9.85072059,13.727 10.8926651,12.687 C11.9346096,11.648 13.6270166,11.65 14.6679573,12.687 L14.6679573,12.687 Z",
    id: 146
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceMortgages);
export default __webpack_public_path__ + "static/media/bank-product-and-service-mortgages.3db19aa3.svg";
export { ForwardRef as ReactComponent };